<!--讲解任务-->
<template>
  <div class="pm50">
    <div class="pd jhnstop row">
      <p class="col">
        <img src="../assets/img/logo.png" class="loginnhjer cz" />
      </p>
      <span class="cf fz15" @click="toHome">首页</span>
    </div>
    <van-cell class="" title="讲解区域：" :value="groundName||'请选择'" :value-class="groundId?'z3':''" is-link @click="showGrounds=true" />
    <no-data v-if="dataLoaded&&orders.length===0" :content-height="contentHeight"></no-data>
    <div  v-else class="pd dataDiv pm15">
      <div class="pd sdfsdtywer mt15 pm15" v-for="(order,index) in orders" :key="index" >
        <div class="fz16 z3 row pt10">
          <p class="col">{{order.customerName}}</p>
          <span class="zts">{{getStatusName(order)}}</span>
        </div>
        <div class="jjnmmnxer mt10 pt10">
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">单 号 </span>
            </span>
            <span class="ml10 fz14 z6">{{order.listNo}}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">参观日期 </span>
            </span>
            <span class="ml10 fz14 z6">{{order.travelDate}}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">参观区域</span>
            </span>
            <span class="ml10 fz14 z6">{{order.ticektTypeName}}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解员</span>
            </span>
            <span class="ml10 fz14 z6">{{order.explainerName}}</span>
          </div>          
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解时段</span>
            </span>
            <span class="ml10 fz14 z6">{{order.sTime}}-{{order.eTime}}</span>
          </div>
           <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">讲解时间</span>
            </span>
            <span class="ml10 fz14 z6">{{order.arrivalTime}}</span>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">人 数</span>
            </span>
            <span class="ml10 fz14 z6">{{order.totalNum}}</span>
          </div>
          <div v-if="order.plateNumbers && order.plateNumbers.length>0" >
            <div class="mt10" v-for="(plateNumber, index) in order.plateNumbers" :key="index">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">车牌号{{index+1}}</span>
              </span>
              <span class="ml10 fz14 z6">{{ plateNumber.licensePlateNumber }} {{ plateNumber.carTypeName }}</span>
            </div>
          </div>
          <div class="mt10">
            <span class="pr f_b">
              <i class="f_i binknxerrt"></i>
              <span class="kkmnmxerert">联系人</span>
            </span>
            <span class="ml10 fz14 z6">{{order.ydrName}}</span>
          </div>

          <div class="mt10 row">
            <div class="col">
              <span class="pr f_b">
                <i class="f_i binknxerrt"></i>
                <span class="kkmnmxerert">手机号码</span>
              </span>
              <span class="ml10 fz14 z6">{{order.mobile}}</span>
            </div>
            <van-button
              v-if="!parkCloseTime && order.editable && order.statusID!=0 && order.statusID!=4"
              class="fz12 dfgdfywer"
              type="primary"
              :loading="loading&&currentIndex===index"
              @click="onClick(index)"
            >{{order.beginTime?'结束接待':'开始接待'}}</van-button>
            <!-- <van-button
              type="primary"
              class="fz12 dfgdfywer"
              v-if="sd.ijksd==0"
              @click="sd.ijksd=1"
            >开始接待</van-button>
            <van-button
              type="primary"
              class="fz12 dfgdfywer"
              v-if="sd.ijksd==1"
              @click="sd.ijksd=2"
            >结束接待</van-button> -->
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet
      v-model="showGrounds"
      :actions="grounds"
      @select="onGroundSelecter"
    />
  </div>
</template>
<script>
import { mapState,mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import moment from "moment";
import NoData from "@/components/NoData.vue";
import orderService from "@/services/orderService.js";
import explainerService from "@/services/explainerService.js";
import signalRHelper from "@/utils/signalRHelper.js";
import scenicService from "./../services/scenicService.js";
const today = moment().format("YYYY-MM-DD");
const connection = signalRHelper.buildExplainerNotificationConnection();
export default {

  data() {
    return {
      loading: false,
      dataLoaded: false,
      currentIndex: -1,
      customerName: "",
      orders: [],      
      groundName: "",
      groundId: "",
      grounds: [],
      showGrounds: true,
    };
  },
  components: {
    NoData
  },
  computed: {
    contentHeight() {
      return this.$store.state.clientHeight - 90;
    },
    ...mapState({
      options: (state) => state.orderModule.options,
      member: (state) => state.memberModule.member,
    }),
    parkCloseTime(){
      var ctime = moment().format("HH:mm");
      if(ctime>=this.options.parkCloseTime)
      {
          return true;
      }else{
        return false;
      }
    }
    // ...mapState(["member"])
  },
  methods: {
    toHome() {
      this.$router.push("/");
    },
    async onGroundSelecter(item) {
      this.groundId = item.value;
      this.groundName = item.name;
      this.showGrounds = false;
      await this.loadOrdersAsync();
    },
    async getGrounds() {
      this.wxLastBookTime = "";
      const grounds = await scenicService.getGroundComboboxItemsAsync({
        travelDate: today,
      });
      this.groundId = "";
      this.grounds = grounds.map((g) => {
        return {
          value: g.value,
          name: g.displayText,
        };
      });
    },
    async onClick(index) {
      if (!this.groundId) {
        this.$toast("请选择讲解区域");
        this.showGrounds = true;
        return;
      }
      this.currentIndex = index;
      let order = this.orders[index];
      try {
        this.loading = true;
        if (order.beginTime) {
          await this.$dialog.confirm({
            title: "确定结束讲解？"
          });
          await explainerService.completeExplainAsync({
            id: order.id,
            listNo: order.listNo,
            timeslotId: order.explainerTimeId,
            groundId:this.groundId
          });

        } else {
          await this.$dialog.confirm({
            title: "确定开始讲解？"
          });
          await explainerService.beginExplainAsync({
            id: order.id,
            listNo: order.listNo,
            timeslotId: order.explainerTimeId,
            groundId:this.groundId
          });
          
        }

      } catch (err) {
        return;
      } finally {
        await this.loadOrdersAsync();
        this.loading = false;
      }
    },
    async loadOrdersAsync() {
      if(!this.member.isExplainer)
      { this.orders.length=[];
        this.showGrounds = false;
        this.$toast("非讲解员不能操作该功能");
        this.$router.go(-1);
        return;
      }
      if (!this.groundId) {
        this.$toast("请选择讲解区域");
        this.showGrounds = true;
        return;
      }
      let result = await orderService.getOrdersForExplainAsync(
        {CustomerName: this.customerName , GroundId:this.groundId, skipCount: 0, maxResultCount: 10000}
      );
      this.orders = result.items;
      this.dataLoaded = true;
      
    },
    layzeLoadOrder() {
      //alert("layzeLoadOrder");
      setTimeout(this.loadOrdersAsync, 300);
    },
    getStatusName(order) {
      //0未入场1已入场2接待中3已接待4已取消
       if(order.statusID ==3)
       {
         return "已接待";
       }
       else
       {
          if(!order.isValid)
          {
              return "未到期";
          }
          else if(order.statusID ==0)
          {
            return "未入场";
          }
          else if(order.statusID ==1)
          {
            return "已入场";
          }
          else if(order.statusID ==2)
          {
            return "接待中";
          }
          else if(order.statusID ==4)
          {
            return "已取消";
          }
       }
      // if (order.completeTime) {
      //   return "已讲解";
      // } else {
      //   return order.isValid ? "讲解中" : "未到期";
      // }
    },    
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  },
  mounted() {},
  async created() {
     if(!this.member.isExplainer)
      { this.orders.length=[];
        this.showGrounds = false;
        this.$toast("非讲解员不能操作该功能");
        this.$router.go(-1);
        return;
      }
    await this.getGrounds();

    await this.loadOrdersAsync();
    
    connection.on("BeginExplain", this.layzeLoadOrder);
    connection.on("CompleteExplain", this.layzeLoadOrder);
    connection.on("CheckIn", this.layzeLoadOrder);
    connection.start();
  },
  beforeDestroy() {
    connection.stop();
    connection.off("BeginExplain");
    connection.off("CompleteExplain");
    connection.off("CheckIn");
  }
};
</script>
<style scoped>
.dataDiv {
  overflow: auto;
  position: fixed;
  width: 100%;
  height: calc(100vh - 90px);
}
</style>
